import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";

const styles = createUseStyles(theme => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    margin: "auto",
    padding: "48px",
    maxWidth: "352px",
    "& h1": {
      fontSize: "16px !important",
      fontWeight: "600 !important",
      lineHeight: "24px !important",
      color: colors.lightBlack,
      margin: "16px 0px 4px !important"
    },
    "& p": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: colors.mediumGrey,
      marginBottom: 0
    }
  },
  retryBtn: {
    marginTop: "24px",
    alignItems: "center",
    padding: "10px 18px",
    "& span": {
      fontSize: "16px",
      fontWeight: "600",
    }
  },
}));

export default styles;